module.exports = __webpack_public_path__ + "static/media/跳空异动@2x.d81079f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_172/images/跳空异动@2x.png
// module id = 1571
// module chunks = 0